// hooks/useTicketDetails.ts
import { useQuery } from "@tanstack/react-query";
import api from "../api";

export interface TicketDetails {
  pikitup_ticket_id: number;
  service_type: number;
  status_flg: number;
  status_text: string;
  assignee_name: string;
  pikitup_cso_name: string;
  service_short_description: string;
  service_long_description: string;
  service_ticket_no: string;
  service_address_info: string;
  customer_first_name: string;
  customer_surname: string;
  created_date: string;
  files: {
    pikitup_ticket_image_id: number;
    filepath: string;
    file_mimetype: string;
  }[];
  activity_logs: {
    created_at: string;
    comment: string | null;
    prev_status: string;
    new_status: string;
    files: any[];
  }[];
  related_tickets_count: string;
  related_tickets: any[];
}

export const useTicketDetails = (ticketId: string | undefined) => {
  return useQuery({
    queryKey: ["ticketDetails", ticketId],
    queryFn: async () => {
      if (!ticketId) throw new Error("Ticket ID is required");
      const { data } = await api.get(
        `/tickets/details/v1?ticket_id=${ticketId}`
      );
      if (data.statusCode !== 200)
        throw new Error(data.message || "Failed to fetch ticket");
      return data.data as TicketDetailsData;
    },
    enabled: !!ticketId,
  });
};
